<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title" :class="{ 'custom-title-copy': isClone }">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
      <div class="row p-3" v-if="currentTab === 'Basic'">
        <challenge @saveIt="isSave = true" @recalculated="recalculated" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Components'">
        <challenge-components ref="components" @saveIt="saveIt" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Resources'">
        <challenge-resources ref="resources" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Members'">
        <challenge-members ref="members" @saveIt="isSave = true" />
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col-md-2">
          <button
            v-if="!isClone && !isAdd"
            class="btn btn-success btn-sm"
            @click="clone"
            title="make a copy of this Challenge"
          >
            Make Copy
          </button>
        </div>
        <div class="col-md-5">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-4">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              :disabled="attemptSave"
              @click="performSave(false)"
            >
              Save
            </button>
            <button
              v-show="isSave && !isAdd"
              class="btn btn-primary me-2"
              :disabled="attemptSave"
              @click="performSave(true)"
            >
              Save and Close
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTabs from '@/Components/ZElements/Tabs'
import Challenge from '@/Components/Challenges/forms/challenge'
import ChallengeComponents from '@/Components/Challenges/forms/challenge-components'
import ChallengeResources from '@/Components/Challenges/forms/challenge-resources'
import ChallengeMembers from '@/Components/Challenges/forms/challenge-members'
export default {
  name: 'challenge-dialog',
  components: {
    ZDialog,
    ZTabs,
    Challenge,
    ChallengeComponents,
    ChallengeResources,
    ChallengeMembers,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lgr',
      currentTab: 'Basic',
      isSave: false,
      attemptSave: false,
      validErrors: [],
      invalidMessage: '',
      isClone: false,
    }
  },
  mounted() {
    this.reset()
  },
  computed: {
    ...mapGetters('challenges', ['challenge']),
    ...mapGetters('usercardio', ['selected']),
    ...mapGetters('organizations', ['examineOrganization']),
    isVisible() {
      return this.show !== null
    },
    tabs() {
      let _tabs = ['Basic']
      if (!this.isAdd) {
        _tabs.push('Components')
        _tabs.push('Resources')
        _tabs.push('Members')
      }
      return _tabs
    },
    title() {
      let _title = 'Edit Challenge'
      if (this.isClone) {
        _title = 'Copy Challenge'
      } else {
        if (this.show) {
          if (this.show.isAdd) {
            _title = 'Add Challenge'
          } else if (this.challenge) {
            _title = `Edit Challenge (${this.challenge.name})`
          }
        }
      }
      return _title
    },
    id() {
      let _id = ''
      if (this.challenge) {
        _id = this.challenge.id
      }
      return _id
    },
    isAdd() {
      let _is = false
      if (this.show) {
        _is = this.show.isAdd
      }
      return _is
    },
  },
  methods: {
    ...mapActions('challenges', ['setChallengeData', 'saveChallenge']),
    async showTab(value) {
      if (this.show.isAdd) {
        this.currentTab = value
      } else {
        let saved = false
        if (this.isSave) {
          saved = await this.performSave(false)
        } else {
          saved = true
        }
        if (saved) {
          this.currentTab = value
          this.isSave = false
        }
      }
      if (this.currentTab === 'Members') {
        if (this.$refs.members) {
          this.$refs.members.init()
        }
      }
    },
    saveIt(dir) {
      this.isSave = dir
    },
    reset() {
      this.currentTab = 'Basic'
      this.validErrors = []
      this.isSave = false
      this.invalidMessage = ''
      this.isClone = false
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.challenge.name === '') {
        valid = false
        this.validErrors.push('name')
      }
      if (this.challenge.description === '') {
        valid = false
        this.validErrors.push('description')
      }
      if (this.show.isAdd) {
      }
      return valid
    },
    isAboutToSave() {
      this.attemptSave = true
    },
    async performSave(closeIt) {
      let success = false
      this.attemptSave = true
      let valid = this.validate()
      if (valid) {
        // capture challenge members
        console.log('Updating Members just prior to save', {
          members: this.show.isAdd ? [] : this.selected,
        })
        this.setChallengeData({
          name: 'members',
          value: this.show.isAdd ? [] : this.selected,
        })
        this.setChallengeData({
          name: 'orgid',
          value: this.examineOrganization.id,
        })
        console.log('Saved', {
          closeId: closeIt,
          isAdd: this.show.isAdd,
          challenge: this.challenge,
        })
        // save the challenge
        if (this.show.isAdd) {
          // save a placeholder component
          let newComponent = {
            name: 'Sessions per Week',
            goal: 1,
            frequency: 2,
            startDate: moment(new Date(this.challenge.start_date))
              .add(1, 'days')
              .format('YYYY-MM-DD'),
            endDate: moment(new Date(this.challenge.end_date)).format(
              'YYYY-MM-DD'
            ),
            isLeaderboard: false,
            rule: 'SessionCount',
            type: 'weekly',
            weight: 100,
          }
          this.setChallengeData({
            name: 'add-component',
            value: newComponent,
          })
        } else {
          // update dates in Resources and Components
          this.setChallengeData({
            name: 'update-dates',
            value: null,
          })
        }
        console.log('Saving Challenge', {
          isAdd: this.show.isAdd,
          challeng: this.challenge,
        })
        await this.saveChallenge(this.challenge)
        this.$emit('saved')
        success = true
        this.isSave = false
        this.isClone = false
        if (closeIt || this.show.isAdd) {
          this.reset()
          this.$emit('close')
        } else {
          this.invalidMessage = 'Changes successfully saved.'
        }
      } else {
        success = false
        this.currentTab = 'Basic'
        this.invalidMessage = 'missing ' + this.validErrors.join(', ')
      }
      this.attemptSave = false
      return success
    },
    clone() {
      this.isClone = true
      this.isSave = true
      this.setChallengeData({
        name: 'copy',
        value: null,
      })
    },
    close() {
      this.reset()
      this.$emit('close')
    },
    recalculated() {
      let $this = this
      this.invalidMessage = 'Successfully recalculated'
      setTimeout(() => {
        $this.invalidMessage = ''
      }, 1500)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-title-copy {
  color: red;
}
</style>
